module.exports = __webpack_public_path__ + "assets/icons-misc-trash-24-px.b953015a.svg";